import classNames from 'classnames';
import map from 'lodash/map';
import React from 'react';
import { addQueryParam } from '../../utils/url';
import classes from './styles/index.module.scss';

const AuthorizedFooter = (props) => {
	const { isAuthenticated, isLoginPage, languages, footerNavigation } = props;

	return (
		<div className={classes.footer}>
			{!isLoginPage && (
				<>
					{!isAuthenticated && languages.length > 1 && (
						<ul className={classes.footerNavigation}>
							{map(languages, (lang) => {
								const languageItemClasses = classNames(classes.footerNavigationItem, {
									[classes.footerNavigationItem_active]: lang.isActive,
								});
								let langHref = '';
								langHref = lang.languageCode
									? addQueryParam(window.location.href, 'lang', lang.languageCode)
									: langHref;
								langHref = lang.cultureCode
									? addQueryParam(langHref, 'cult', lang.cultureCode)
									: langHref;

								return (
									<li
										className={languageItemClasses}
										key={lang.id}
									>
										<a href={langHref}> {lang.name} </a>
									</li>
								);
							})}
						</ul>
					)}
					<hr className={classes.footerHr} />
					<ul className={classes.footerNavigation}>
						<li className={classes.footerNavigationItem}>&copy;&nbsp;{new Date().getFullYear()}</li>
						{map(footerNavigation, (navItem) => (
							<li
								className={classes.footerNavigationItem}
								key={navItem.url}
							>
								<a href={navItem.url}>{navItem.title}</a>
							</li>
						))}
					</ul>
				</>
			)}
		</div>
	);
};

AuthorizedFooter.propTypes = {};

export { AuthorizedFooter };
